import { render, staticRenderFns } from "./FaturamentoChart.vue?vue&type=template&id=1664dd62"
import script from "./FaturamentoChart.vue?vue&type=script&lang=js"
export * from "./FaturamentoChart.vue?vue&type=script&lang=js"
import style0 from "./FaturamentoChart.vue?vue&type=style&index=0&id=1664dd62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports